import React from "react";
import { Avatar, Box } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const EcoProfileAvatar: React.FC = () => {
  return (
    <Box display="flex" justifyContent="center" mt={2}>
      <Avatar
        sx={{
          bgcolor: "#F5F9E9",
          color: "#162C1F",
          width: 80,
          height: 80,
          border: "3px solid #162C1F",
          boxShadow: 2,
        }}
      >
        <PersonOutlineIcon fontSize="large" />
      </Avatar>
    </Box>
  );
};

export default EcoProfileAvatar;